import '../include/allpages'
import '../include/WidgetPriceAndComplectation'
import '../include/WidgetNewCarsFilter'
import '../include/compareCarColors'
import '../include/WidgetNewCarsSpecCompare'
import '../include/used-rows';
import '../include/PhotoGallery';
import "../include/WidgetCostOwnership";
import setChangeColorButtonHandler from "../include/setChangeColorButtonHandler";
import {GaEvents} from "../include/gaEvents";

$(function () {
    setChangeColorButtonHandler(
        '#jsChangeColorImage',
        '.jsChangeColorButton',
        '#jsColorName'
    );
    OpenComplectationDescription();
    EqDiffGallery();
    EqDiffItems();
    PlusMinus();

    window.formComponent.forms['model_form'] = {
        onAjaxComplete: function (context) {
            window.formComponent.onAjaxComplete(context);
            GaEvents.send(GaEvents.EVENT10_GETOFFER);
        }
    };
    
    $(".accordion-close").on('click', function() {
        var scrollTop = $('html, body').scrollTop();
        $('html, body').scrollTop(scrollTop - $(this).parent().height() - 70);
        $(this).parents(".accordion:eq(0)").find("input").trigger('click');
        return false;
    });
});

function OpenComplectationDescription() {
    $('.complectation-row .name').click(function () {
        $(this).parent('.complectation-row').toggleClass('open');
        $(this).toggleClass('active');
        $(this).parent('.complectation-row').next('.complectation-dscr').toggleClass('open');
    });
    $('.eq-close').click(function () {
        $(this).parents('.complectation-dscr').removeClass('open').css('background', 'red');
        $(this).parents('.complectation-dscr').prev('.complectation-row').removeClass('open');
        $(this).parents('.complectation-dscr').prev('.complectation-row').children('.name').removeClass('active');
        console.log('close');
    });
}


function EqDiffGallery() {
    $('.eq_diff-gallery').slick({
        centerMode: true,
        centerPadding: '30px',
        slidesToShow: 1,
        //infinite: false,
        prevArrow: '<div class="sl-min sl-prev">',
        nextArrow: '<div class="sl-min sl-next">',
    });
}

function EqDiffItems() {
    $('.eq_diff-items').slick({
        prevArrow: '<div class="sl-big sl-prev">',
        nextArrow: '<div class="sl-big sl-next">',
        infinite: false,
        speed: 300,
        dots: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 641,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]

    });
}

function PlusMinus() {
    $('.tth-table-body tbody td.ico').each(function () {
        if ($(this).is(':contains("+")')) {
            $(this).addClass('ico-plus');
        } else if ($(this).is(':contains("-")')) {
            $(this).addClass('ico-minus');
        }
    })
}

